import { useContext } from 'react';
import { FileUploadEffectsContext } from '@trinity/chat-components/containers/WorkspaceFileUpload/Context.js';

export const useFileUploadEffects = () => {
  return useContext(FileUploadEffectsContext);
};

export default useFileUploadEffects;